// extracted by mini-css-extract-plugin
module.exports = {"circleButton":"CountButton_circleButton__WTw9K","minus":"CountButton_minus__OOxdb","plus":"CountButton_plus__nU8u0"};